import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=71b07738&scoped=true"
import script from "./auth.vue?vue&type=script&lang=js"
export * from "./auth.vue?vue&type=script&lang=js"
import style0 from "./auth.vue?vue&type=style&index=0&id=71b07738&prod&lang=scss&scoped=true"
import style1 from "./auth.vue?vue&type=style&index=1&id=71b07738&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b07738",
  null
  
)

export default component.exports